define((require) => {
    const TagCompositeView          = require("ui/assets/image/TagCompositeView");
    const ImageTagItemView          = require("ui/assets/image/tags/ImageTagItemView");
    const template                  = require("ui/assets/image/inventory/InventoryTagCompositeView.tpl");

    /**
     * Renders a collection of tags.
     *
     * @see ImageTagCollection
     * @see ImageTagModel
     *
     * @class ImageTagCompositeView
     */
    return TagCompositeView.extend({

        template,

        itemViewContainer: ".inventory-tags-list",

        events: {
            "submit .inventory-tag-new-form": "_tagSubmitHandler",
            "keydown @ui.inventoryInput": "_tagInputKeydownHandler"
        },

        ui: {
            formGroup: ".inventory-form-group",
            tagInput: ".inventory-tag-input",
            tagInputMessage: ".inventory-tag-input-message"
        },

        collectionEvents: {
            "sort": "_resortView"
        },

        templateHelpers() {
            return {
                editable: this.options.editable,
                maxNameLength: ImageTagItemView.TAG_NAME_MAX_LENGTH
            };
        },

        _tagInputKeydownHandler() {
            this.$formGroup.toggleClass("has-error", false);
        },

        _tagSubmitHandler() {
            const newTagNameValue = this.$input.val().toUpperCase().trim();
            const validation = this._validateTag(newTagNameValue);

            this.$formGroup.toggleClass("has-error", !validation.valid);

            if (validation.valid) {
                const newTag = {name: newTagNameValue, type: "ZMAGS_GROUP_ID", confidence: 100};
                this.collection.add(newTag, {triggerSource: this});
                this.options.tagCollection.add(newTag, {triggerSource: this});
                this.$input.val("");
            } else {
                this.$el.find(this.ui.tagInputMessage).text(validation.error);
            }

            return false;
        },

        _validateTag(value) {
            if (value.length === 0) {
                return {
                    valid: false,
                    error: "Missing Inventory ID"
                };
            }

            /**
             * Checks to see if another tag of type ZMAGS_GROUP_ID already exists.
             */
            const existingType = this.collection.isEmpty();

            if (existingType && existingType.length) {
                return {
                    valid: false,
                    error: "Inventory ID already exists!"
                };
            }

            /**
             * Note that the application is case insensitive. You cannot have two inventory tags of same name but capitalized!
             * Also note that we are comparing only amongst in inventory tags.
             * You can have an inventory and non-inventory tag with the same name.
             * @type {boolean}
             */
            const existingName = this.collection.find((model) => {
                return model.get("name").toUpperCase() === value.toUpperCase();
            });

            if (existingName) {
                return {
                    valid: false,
                    error: "Inventory ID already exists!"
                };
            }

            return {
                valid: true,
                error: null
            };
        },

        _resortView() {
            this._focusInputOnRender = this.$input.is(":focus");
            this.render();
        },

        onRender() {
            this.$input = this.$el.find(this.ui.tagInput);
            this.$formGroup = this.$el.find(this.ui.formGroup);

            if (this._focusInputOnRender) {
                this.$el.find(this.ui.tagInput).focus();
                this._focusInputOnRender = false;
            }

            if (this.collection.length > 19) {
                this.$input.prop("disabled", true);
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/image/inventory/InventoryTagCompositeView.js